import React, { Component } from 'react';
import SocialButtons from './socialButtons';
import './socialButtonsForTop.css';
import { readPublicMetadata } from '../../../../api/publicMetadata';

export default class SocialButtonsForTop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            social: {},
        };
    }

    componentDidMount() {
        readPublicMetadata()
            .then((metadata) => this.setState({ email: metadata.email, social: metadata.social }))
            .catch(() => {});
    }

    handleClick(e, href) {
        window.open(href, "_blank");
    }

    render() {
        const { email, social } = this.state;

        return (
            <div className="socialForTop">
                <div className="contact">
                    <p className="footerMessage"> Portais para outros mundos </p>
                    <SocialButtons className="socialIcons" social={social} />
                    <div className="emailBox">
                        Nos envie um pergaminho! <a href={`mailto:${email}`} > {email} </a>
                    </div>
                    <br />
                </div>
            </div>
        );
    }
}
